// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1WSynYzYOMVLh7J0o23EvG"};